import React, { useEffect, useState } from "react";
import axios from "axios";
import { Spinner, Table, Button } from "react-bootstrap";

const DashboardAll = () => {
  const [loading, setLoading] = useState(true);
  const [surveyList, setSurveyList] = useState([]);

  useEffect(() => {
    const fetchSurveys = async () => {
      try {
        const response = await axios.get(
          "https://onegml.com/cls/dashboard_functions/pooldata.php?sel=29"
        );
        setSurveyList(response.data);
      } catch (error) {
        console.error("Error fetching surveys:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSurveys();
  }, []);

  const handleGoToDashboard = (value, label) => {
    const encodedTitle = encodeURIComponent(label);
    const url = `/${value}/${encodedTitle}`;
    window.open(url, "_blank");
  };

  return (
    <>
      {loading ? (
        <div className="text-center p-5">
          <Spinner animation="border" />
        </div>
      ) : (
        <div className="p-4">
          <h4 className="mb-4">Available Surveys</h4>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Survey Title</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {surveyList.map((survey, index) => (
                <tr key={survey.value}>
                  <td>{index + 1}</td>
                  <td>{survey.label}</td>
                  <td>
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={() => handleGoToDashboard(survey.value, survey.label)}
                    >
                      Go to Dashboard
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </>
  );
};

export default DashboardAll;
